export const SHORTS_OG_IMAGE_WIDTH = 1200;
export const SHORTS_OG_IMAGE_HEIGHT = 630;
export const SHORTS_OG_IMAGE_TYPE = 'image/jpeg';

const SHORTS_THUMB_CDNS = ['hls', 'hls-staging'] as const;

export type ShortsThumbCdn = (typeof SHORTS_THUMB_CDNS)[number];

export interface ShortsThumbRef {
	cdn: ShortsThumbCdn;
	id: string;
	version: string;
}

const ID_PATTERN = /^[A-Za-z0-9]{1,32}$/;
const VERSION_PATTERN = /^[A-Za-z0-9-]{1,64}$/;

const THUMB_URL_PATTERN =
	/^https:\/\/(hls(?:-staging)?)\.pilarhomes\.com\.br\/portal-property-showcase\/([^/?#]+)\/([^/?#]+)\/thumb\.webp(?:\?[^#]*)?$/;

function isShortsThumbCdn(value: string): value is ShortsThumbCdn {
	return (SHORTS_THUMB_CDNS as readonly string[]).includes(value);
}

export function toShortsThumbRef(
	cdn: string | undefined,
	id: string | undefined,
	version: string | undefined
): ShortsThumbRef | null {
	if (!cdn || !id || !version) return null;
	if (!isShortsThumbCdn(cdn)) return null;
	if (!ID_PATTERN.test(id) || !VERSION_PATTERN.test(version)) return null;
	return { cdn, id, version };
}

export function parseShortsThumbUrl(
	url: string | null | undefined
): ShortsThumbRef | null {
	if (!url) return null;
	const match = THUMB_URL_PATTERN.exec(url);
	if (!match) return null;
	return toShortsThumbRef(match[1], match[2], match[3]);
}

export function buildShortsThumbUrl({
	cdn,
	id,
	version
}: ShortsThumbRef): string {
	return `https://${cdn}.pilarhomes.com.br/portal-property-showcase/${id}/${version}/thumb.webp?v=${version}`;
}

export function buildShortsOgImagePath({
	cdn,
	id,
	version
}: ShortsThumbRef): string {
	return `/og/shorts/${cdn}/${id}/${version}.jpg`;
}
